module.exports = __webpack_public_path__ + "img/20190706154406085.3ead46d8.png";